import { OrganizationTypesEnum } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useDefenseCounselsLookup = () => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-organization-in-zone'],
        queryFn: async () => {
            const response = await zoneApiClient.getOrganizationsInZone(
                OrganizationTypesEnum.Firm.Value
            );

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve defense counsel.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
